import { Module } from 'vuex-smart-module';
import EventsCalendarActions from './actions';
import EventsCalendarGetters from './getters';
import EventsCalendarMutations from './mutations';
import EventsCalendarState from './state';

export default new Module({
  state: EventsCalendarState,
  mutations: EventsCalendarMutations,
  actions: EventsCalendarActions,
  getters: EventsCalendarGetters,
});
